import Reveal from "@/components/base/Reveal";

const highlights = [
  { value: "16", label: "九宫八卦主题园" },
  { value: "1000+", label: "样板认种地块" },
  { value: "18", label: "木屋别墅" },
];

export default function FarmPanorama() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/4482546e014370507f3d90ff31782979/c9148962b3ae3c2a111e826989387e28.png"
          alt="味聚华夏农耕酵素农场样板示范区全景"
          title="味聚华夏农耕酵素农场 · 九宫八卦田园仙境"
          loading="lazy"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/15"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <Reveal className="max-w-xl">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/15 backdrop-blur text-white text-xs md:text-sm font-medium">
            <i className="ri-live-line"></i>
            样板示范区实景
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mt-5 leading-tight">
            木屋藏在林间，梯田环抱湖心
          </h2>
          <p className="text-white/85 text-sm md:text-base mt-4 leading-relaxed">
            依山就势的层层梯田、倒映云天的湖心亭、错落有致的木屋别墅，共同构成味聚华夏的样板示范区。每一栋木屋都对应一家餐厅，每一块田园都有它真正的主人。
          </p>
          <div className="flex flex-wrap gap-6 md:gap-10 mt-8">
            {highlights.map((item) => (
              <div key={item.label}>
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">
                  {item.value}
                </p>
                <p className="text-white/70 text-xs md:text-sm mt-1">{item.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}